import Rollbar from "rollbar";
import config from "../config";

export const rollbar = new Rollbar({
  accessToken: config.rollbar.accessToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: config.environment,
  reportLevel: 'error'
});